import React, { useMemo } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { JsonForms } from '@jsonforms/react'

import { materialCells } from '@jsonforms/material-renderers'
import DynamicWrapper from 'designer/component/system/layout/control/DynamicWrapper'
import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'

import {
  createSwitchRenderer,
  createDisplayRenderer,
} from 'designer/component/control/renderer'

export const EditSystemPanel = (props) => {
  let { data, schema, uischema, config } = props
  const { isFirstElement } = config
  const renderers = useMemo(
    () => createSwitchRenderer(uischema.elements, isFirstElement),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <DynamicWrapper {...props} isFirstElement={isFirstElement}>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </DynamicWrapper>
  )
}

export const SubEditSystemPanel = (props) => {
  let { data, schema, uischema, config } = props
  const { isFirstElement } = config
  const renderers = useMemo(
    () => createSwitchRenderer(uischema.elements, isFirstElement),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <DynamicWrapper {...props} isFirstElement={isFirstElement}>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </DynamicWrapper>
  )
}

export const EditDisplayPanel = (props) => {
  let { data, schema, uischema, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [uischema.key]
  )

  return (
    <ComponentWrapper {...props}>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </ComponentWrapper>
  )
}

export const SubEditDisplayPanel = (props) => {
  let { data, schema, uischema, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [uischema.key]
  )

  return (
    <ComponentWrapper {...props}>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </ComponentWrapper>
  )
}

export const editPanelTester = rankWith(3, scopeEndsWith('editPanel'))

export const editPanelSystem = {
  tester: editPanelTester,
  renderer: withJsonFormsControlProps(EditSystemPanel),
}

export const subEditPanelSystem = {
  tester: editPanelTester,
  renderer: withJsonFormsControlProps(SubEditSystemPanel),
}

export const editPanelDisplay = {
  tester: editPanelTester,
  renderer: withJsonFormsControlProps(EditDisplayPanel),
}

export const subEditPanelDisplay = {
  tester: editPanelTester,
  renderer: withJsonFormsControlProps(SubEditDisplayPanel),
}
